import React from 'react';

const EmptyTransactionsMessage = () => (
    <div className="empty-transaction">
        <div className="title">No transactions yet</div>
        <div className="message">Once you have transactions they will appear here</div>
    </div>
);

export default EmptyTransactionsMessage;